// extracted by mini-css-extract-plugin
export default {"errorContainer":"theme_errorContainer__q6J8i"};